import React, { useState, useEffect } from "react";
import { navigate } from "@reach/router";
import Layout from "../../Layout";
import { H2 } from "../../Common/Typography";
import {
  BodyContent,
  Container,
  BodyWhitePattern,
} from "../../Common/GridSystem";
import BackNav from "../../Common/BackNav";
import { AuthService } from "../../../services/AuthService";
import RoleSkills from "./RoleSkills";
import SelectMenu from "../../Common/FormElements/SelectMenu";
import { IndustreRoleStore } from "../../../store/store_state";
import { SourceType } from "../../../enums/SourceType";
import { SortString } from "../../../helpers/SortString";
import { isGenAiDisprzAtomicSkillSource,isDisprzAtomicSkillSource } from "../../../helpers/CommonHelper";

export default (props) => {
  const { id } = props;

  const [leaderRoles, setLeaderRoles] = useState([]);
  const [leader, setLeader] = useState(id);
  const [source, setSoure]=useState(SourceType.DISPRZ_ATOMIC_SKILLS);
  const [sourceList, setSourceList] = useState([]);

  const getLeaderRoles = async () => {
    try {
      const res = await AuthService.leaderShipRolesV3();
      setLeaderRoles(
        res.map((el) => ({
          label: el.leadershipRoleName,
          value: el.leadershipRoleId,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getLeaderRoles();
    IndustreRoleStore.update((s) => {s.sourceId = SourceType.DISPRZ_ATOMIC_SKILLS});
    getFrameWorkList();
    return () => {
      setLeaderRoles([]);
    };
  }, []);

  const handleLeader = (val) => {
    setLeader(val);
    navigate(`/leader/${val}`);
    window.location.reload();
  };

  const getFrameWorkList = async () => {
    try {
      const res = await AuthService.sourceListV3();

      const sorted = SortString(
        res.filter((el) => !!el.source),
        "source"
      );

      const filtered = sorted.filter(
        (el) =>
          isGenAiDisprzAtomicSkillSource(el.sourceId) ||
          isDisprzAtomicSkillSource(el.sourceId)
      );

      const mapped = filtered.map((el) => ({
        label: el.source,
        value: el.sourceId,
      }));

      setSourceList(mapped);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSource = async (val)=>{
     setSoure(val);
     IndustreRoleStore.update((s) => {
        s.sourceId = val;
     });
  }

  return (
    <Layout>
      <H2>Leadership Role Management</H2>
      <BodyContent>
        <Container>
          <BackNav linkNav="/role" />
          <BodyWhitePattern style={{ paddingBottom: 10, display: "flex", columnGap: "46px" }}>
            <SelectMenu
              width="250px"
              label="Leadership Role"
              value={leader}
              list={leaderRoles}
              handleSelect={handleLeader}
            />
            <SelectMenu
              width="250px"
              label="Source"
              value={source}
              list={sourceList}
              handleSelect={handleSource}
            />
          </BodyWhitePattern>
          <br />
          <RoleSkills roleId={leader} type="LEADER" sourceId={source}/>
        </Container>
      </BodyContent>
    </Layout>
  );
};
